var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, HStack, Heading, IconButton, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useModalPaddings } from '../hooks';
import { Modal } from './Modal';
import { DeleteIcon } from './icons';
var DefaultDeleteButton = function (_a) {
    var onClick = _a.onClick, other = __rest(_a, ["onClick"]);
    return (React.createElement(IconButton, __assign({ "aria-label": 'Delete button', color: 'typography.secondary', "data-testid": 'delete-data', icon: React.createElement(DeleteIcon, { boxSize: 4 }), size: 'sm', onClick: onClick }, other)));
};
var ConfirmPopup = function (_a) {
    var onConfirm = _a.onConfirm, _b = _a.PreviewButton, PreviewButton = _b === void 0 ? DefaultDeleteButton : _b, _c = _a.header, header = _c === void 0 ? 'Confirmation' : _c, _d = _a.message, message = _d === void 0 ? 'Are you sure you want to delete?' : _d, _e = _a.positiveButtonText, positiveButtonText = _e === void 0 ? 'Delete' : _e, _f = _a.negativeButtonText, negativeButtonText = _f === void 0 ? 'Cancel' : _f, positiveButtonProps = _a.positiveButtonProps, _g = _a.isMobile, isMobile = _g === void 0 ? false : _g, other = __rest(_a, ["onConfirm", "PreviewButton", "header", "message", "positiveButtonText", "negativeButtonText", "positiveButtonProps", "isMobile"]);
    var _h = useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var onOpen = function () { return setIsOpen(!isOpen); };
    var onClose = function () { return setIsOpen(false); };
    var modalPadding = useModalPaddings(isMobile);
    var _j = useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, onConfirm()];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(PreviewButton, __assign({ onClick: onOpen }, other)),
        React.createElement(Modal, { isMobile: isMobile, isOpen: isOpen, onClose: onClose },
            React.createElement(VStack, __assign({ spacing: 5 }, modalPadding),
                React.createElement(Heading, { as: 'div', size: 'md', textAlign: 'center' }, header),
                React.createElement(Text, { textAlign: 'center' }, message),
                React.createElement(HStack, { w: '100%' },
                    React.createElement(Button, { variant: 'outline', w: '100%', onClick: onClose }, negativeButtonText),
                    React.createElement(Button, __assign({ colorScheme: 'delete', "data-testid": 'approve-confirmation', isLoading: isLoading, w: '100%', onClick: handleConfirm }, positiveButtonProps), positiveButtonText))))));
};
export default ConfirmPopup;
//# sourceMappingURL=ConfirmPopup.js.map